import React, { useState } from 'react';
import { useTheme, themes } from './ThemeProvider';
import { MdPalette, MdClose } from 'react-icons/md';

const ThemeSwitcher = () => {
  const { currentTheme, switchTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '52px',
          height: '52px',
          borderRadius: '50%',
          background: 'var(--primary-gradient)',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '22px',
          color: 'white',
          boxShadow: 'var(--shadow-green)',
          zIndex: 999,
          transition: 'all 0.3s ease'
        }}
        title="Change Theme"
      >
        {isOpen ? <MdClose /> : <MdPalette />}
      </button>

      {isOpen && (
        <div style={{
          position: 'fixed',
          bottom: '88px',
          right: '24px',
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          borderRadius: '16px',
          padding: '16px',
          zIndex: 999,
          boxShadow: 'var(--shadow-lg)',
          minWidth: '200px'
        }}>
          <p style={{
            fontSize: '12px', fontWeight: '700',
            color: 'var(--text-secondary)', textTransform: 'uppercase',
            letterSpacing: '0.08em', marginBottom: '12px'
          }}>
            Select Theme
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {Object.entries(themes).map(([key, theme]) => (
              <button
                key={key}
                onClick={() => { switchTheme(key); setIsOpen(false); }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px 14px',
                  borderRadius: '10px',
                  border: currentTheme === key
                    ? '2px solid var(--primary)'
                    : '1px solid var(--border)',
                  background: currentTheme === key
                    ? 'rgba(var(--primary-rgb), 0.1)'
                    : 'var(--bg-dark)',
                  cursor: 'pointer',
                  color: 'var(--text-primary)',
                  fontSize: '14px',
                  fontWeight: currentTheme === key ? '700' : '400',
                  transition: 'all 0.2s ease',
                  fontFamily: 'Inter, sans-serif',
                  width: '100%',
                  textAlign: 'left'
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = 'var(--primary)';
                  e.currentTarget.style.transform = 'translateX(4px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = currentTheme === key ? 'var(--primary)' : 'var(--border)';
                  e.currentTarget.style.transform = 'translateX(0)';
                }}
              >
                <span style={{ fontSize: '20px' }}>{theme.emoji}</span>
                <span>{theme.name}</span>
                {currentTheme === key && (
                  <span style={{
                    marginLeft: 'auto',
                    width: '8px', height: '8px',
                    borderRadius: '50%',
                    background: 'var(--primary)',
                    boxShadow: 'var(--shadow-green)'
                  }} />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ThemeSwitcher;